import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const ActiveFeesIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.60817 16.4166C6.2915 15.6833 7.33317 15.7416 7.93317 16.5416L8.77484 17.6666C9.44984 18.5583 10.5415 18.5583 11.2165 17.6666L12.0582 16.5416C12.6582 15.7416 13.6998 15.6833 14.3832 16.4166C15.8665 18 17.0748 17.475 17.0748 15.2583V5.86663C17.0832 2.50829 16.2998 1.66663 13.1498 1.66663H6.84984C3.69984 1.66663 2.9165 2.50829 2.9165 5.86663V15.25C2.9165 17.475 4.13317 17.9916 5.60817 16.4166Z"
        fill="#286AF6"
      />
      <path
        d="M12.4998 11.6667C12.0332 11.6667 11.6665 11.2917 11.6665 10.8333C11.6665 10.375 12.0415 10 12.4998 10C12.9582 10 13.3332 10.375 13.3332 10.8333C13.3332 11.2917 12.9665 11.6667 12.4998 11.6667Z"
        fill="white"
      />
      <path
        d="M7.49984 7.50004C7.03317 7.50004 6.6665 7.12504 6.6665 6.66671C6.6665 6.20837 7.0415 5.83337 7.49984 5.83337C7.95817 5.83337 8.33317 6.20837 8.33317 6.66671C8.33317 7.12504 7.9665 7.50004 7.49984 7.50004Z"
        fill="white"
      />
      <path
        d="M7.19176 12.125C7.03343 12.125 6.8751 12.0667 6.7501 11.9417C6.50843 11.7 6.50843 11.3 6.7501 11.0584L12.3584 5.45005C12.6001 5.20838 13.0001 5.20838 13.2418 5.45005C13.4834 5.69172 13.4834 6.09172 13.2418 6.33338L7.63343 11.9417C7.51676 12.0667 7.3501 12.125 7.19176 12.125Z"
        fill="white"
      />
    </CustomSvg>
  );
};
export default ActiveFeesIcon;
